import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
export function randomSeed() {
  return Math.floor(Math.random() * Math.pow(2, 31));
}
export var Random = /*#__PURE__*/function () {
  function Random(seed) {
    _classCallCheck(this, Random);

    this.seed = seed;
  }

  _createClass(Random, [{
    key: "next",
    value: function next() {
      if (this.seed) {
        return (Math.pow(2, 31) - 1 & (this.seed = Math.imul(48271, this.seed))) / Math.pow(2, 31);
      } else {
        return Math.random();
      }
    }
  }]);

  return Random;
}();